<template>
  <v-stepper v-model="step"
             alt-labels
             class="EC_Stepper mb-4">
    <v-stepper-header>

      <v-stepper-step step="1"
                      :complete="step > 1">
        Select Template
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2"
                      :complete="step > 2">
        Select Email List
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3"
                      :complete="step > 3">
        Review &amp; Send
      </v-stepper-step>

    </v-stepper-header>
  </v-stepper>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  name: 'email-campaign-stepper',
  computed: {
    ...mapGetters('emailCampaignCart', [
      'contacts',
      'templates',
      'step',
    ]),
  },
}
</script>
